import {Card, CardHeader, CardContent, Grid, CardActions, Button, Stack} from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';
import {ControlledTextField} from "../../components/forms";
import {useForm} from "react-hook-form";
import {ChangePasswordData, ChangePasswordDataFields, User, UserFields} from "../../types/user/authData";
import {useEffect} from "react";
import {HttpOnboardingUser} from "../../http/onboarding/httpOnboardingUser";
import {useAction} from "../../hooks/useAction";
import {HttpAuth} from "../../http/user/httpAuth";
import {userStorage} from "../../utils/localStorage/userStorage";
import {BaseResponseFields} from "../../types/baseEntities";
import {ControlledPasswordField} from "../../components/forms/ControlledPasswordField";
import useAxios from "../../hooks/useAxios";

const AccountData = () => {
    const userMethods = useForm<User>()
    const passwordMethods = useForm<ChangePasswordData>()
    const {fetchData} = useAxios()
    const {snackbarSuccess, snackbarError} = useAction()
    
    const getDataUser = () => {
        HttpOnboardingUser.getData().then((r) => {
            userMethods.reset(r)
        })
    }
    
    useEffect(() => {
        getDataUser()
    }, [])
    
    const onSubmitMyData = (data: User) => {
        HttpOnboardingUser.updateData(data).then(() => {
            snackbarSuccess('Los datos personales se actualizaron correctamente')
            getDataUser()
        }).catch(() => snackbarError('Ocurrió un error al guardar los datos personales'))
    }
    
    const onSubmitPassword = (data: ChangePasswordData) => {
        const submitData: ChangePasswordData = {
            ...data,
            [ChangePasswordDataFields.IdUsuario]: userStorage.getUserId()
        }
        fetchData(() => HttpAuth.changePassword(submitData), true)
        .then((r) => {
            r[BaseResponseFields.HasError] ? 
                snackbarError(r[BaseResponseFields.ErrorDescription])
            :
            snackbarSuccess('La contraseña se actualizó correctamente')
        })
    }
    
    return (
        <Stack spacing={3}>
            <Card>
                <CardHeader title={'Mis Datos'} />
                <form onSubmit={userMethods.handleSubmit(onSubmitMyData)}>
                    <CardContent>
                        <Grid container spacing={6} pt={1}>
                            <Grid item md={2}>
                                <ControlledTextField control={userMethods.control}
                                                     label={'Nombre'}
                                                     fullWidth
                                                     name={UserFields.Nombre}
                                />
                            </Grid>
                            <Grid item md={2}>
                                <ControlledTextField control={userMethods.control}
                                                     label={'Apellido'}
                                                     fullWidth
                                                     name={UserFields.Apellido}
                                />
                            </Grid>
                            <Grid item md={4}>
                                <ControlledTextField control={userMethods.control}
                                                     label={'Correo electrónico'}
                                                     fullWidth
                                                     name={UserFields.Email}
                                />
                            </Grid>
                            <Grid item md={4}>
                                <ControlledTextField control={userMethods.control}
                                                     label={'Cargo'}
                                                     fullWidth
                                                     name={UserFields.Cargo}
                                />
                            </Grid>
                            <Grid item md={2}>
                                <ControlledTextField control={userMethods.control}
                                                     label={'DNI'}
                                                     fullWidth
                                                     name={UserFields.DNI}
                                />
                            </Grid>
                            <Grid item md={2}>
                                <ControlledTextField control={userMethods.control} 
                                                     label={'Genero'} 
                                                     fullWidth
                                                     name={UserFields.Genero}
                                />
                            </Grid>
                            <Grid item md={2}>
                                <ControlledTextField control={userMethods.control}
                                                     label={'Tipo Celular'}
                                                     fullWidth
                                                     name={UserFields.TipoCelular}
                                />
                            </Grid>
                            <Grid item md={1.5}>
                                <ControlledTextField control={userMethods.control}
                                                     label={'Cód. Área'}
                                                     fullWidth
                                                     name={UserFields.CodArea}
                                />
                            </Grid>
                            <Grid item md={2.5}>
                                <ControlledTextField control={userMethods.control}
                                                     label={'Teléfono'}
                                                     fullWidth
                                                     name={UserFields.Telefono}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                    <CardActions sx={{justifyContent: 'flex-end'}}>
                        <Button variant='contained' color='primary' startIcon={<SaveIcon />} type='submit'>
                            Guardar cambios
                        </Button>
                    </CardActions>
                </form>
            </Card>
            <Card>
                <CardHeader title={'Cambiar Contraseña'} />
                <form onSubmit={passwordMethods.handleSubmit(onSubmitPassword)}>
                    
                    <CardContent>
                        <Grid container spacing={6} pt={1}>
                            <Grid item md={3} xs={6}>
                                <ControlledPasswordField control={passwordMethods.control} 
                                                         label={'Contraseña Actual'} 
                                                         fullWidth 
                                                         name={ChangePasswordDataFields.PasswordActual}
                                />
                            </Grid>
                            <Grid item md={3} xs={6}>
                                <ControlledPasswordField control={passwordMethods.control} 
                                                         label={'Nueva Contraseña'} 
                                                         fullWidth 
                                                         name={ChangePasswordDataFields.PasswordNueva}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                    <CardActions sx={{justifyContent: 'flex-end'}}>
                        <Button variant='contained' color='primary' startIcon={<SaveIcon />} type='submit'>
                            Guardar contraseña
                        </Button>
                    </CardActions>
                </form>
            </Card>
        </Stack>
    )
}


export default AccountData